import { Component, EventEmitter, Input, Output, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { EventService } from '../../../core/services/event.service';
import { NgForm } from '@angular/forms';
import * as _ from "lodash";
import {Angulartics2} from "angulartics2";

@Component({
    selector: 'main-tab-address',
    templateUrl: './address.component.html',
    styleUrls: ['../profile.page.scss']
})
export class AddressComponent implements OnInit {
    @Output() onFormAdd = new EventEmitter();
    @Input() dictData: any;
    form: NgForm;

    stateProvinces: any;

    model: any;
    state: any = {
        isSubmitted: false
    };

    isCreation: boolean;
    isFormVisible: boolean = false;
    editModel: any;

    @ViewChild('form') set content(content: NgForm) {
        this.form = content;
    }

    constructor(
        private eventService: EventService,
        private http: HttpClient,
        private toastr: ToastrService,
        private angulartics2: Angulartics2
    ) {}

    ngOnInit() {
        this.stateProvinces = this.dictData.StateProvince[0].stateProvinces.concat(this.dictData.StateProvince[1].stateProvinces);
        this.stateProvinces = this.stateProvinces.sort((a,b) => {
            if(a.description < b.description) return -1;
            if(a.description > b.description) return 1;
            return 0;
        });

        this.convertToModels(this.eventService.selectedEvent.gql);
        this.eventService.onEventChange.subscribe(event => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
        this.eventService.onGqlReload.subscribe(() => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
    }

    convertToModels(gqlRes) {
        let constituent = gqlRes.Participant[0].individualConstituent;
        this.model = {
            addresses: []
        };

        constituent.constituentAddresses.forEach(address => {
            this.model.addresses.push({
                constituentAddressID: address.constituentAddressId,
                address1: address.address1,
                address2: address.address2,
                addressType: {
                    constituentAddressTypeID: address.addressType.addressTypeId,
                    name: address.addressType.name,
                    description: address.addressType.description
                },
                city: address.city,
                country: address.country,
                postalCode: address.postalCode,
                state: address.state,
                primary: address.primaryFl
            });
        });
    }

    /** Edit/create **/
    cancel() {
        this.isFormVisible = false;
        this.editModel = null;
        this.state.isSubmitted = false;
    }

    create() {
        this.isCreation = true;
        this.isFormVisible = true;
        this.editModel = {
            addressType: {},
            primary: false
        };
        setTimeout(() => {
            this.onFormAdd.emit(this.form);
        }, 1);
    }

    edit(address) {
        this.isCreation = false;
        this.isFormVisible = true;
        this.editModel = _.cloneDeep(address);
        setTimeout(() => {
            this.onFormAdd.emit(this.form);
        }, 1);
    }

    validatePrimaryAddress() {
       if (this.editModel.primary) {
          return true;
       }
       let hasPrimaryAddress: boolean = false;

       this.model.addresses.forEach(address => {
           if (address.constituentAddressID != this.editModel.constituentAddressID) {
               if (address.primary) {
                 hasPrimaryAddress = true;
               }
           }
       });

       return hasPrimaryAddress;
    }


    save() {
        this.state.isSubmitted = true;
        if (!this.form.valid) return;

        if (!this.validatePrimaryAddress()) {
          this.toastr.error("There should be a primary address set");
          return;
        }

        this.form.form.markAsPristine();
        if (this.isCreation) {
            this.http.post('/api/v1/user/addresses', this.editModel)
                .subscribe(res => {
                    this.eventService.getAddresses(true).subscribe(() => {});
                    this.toastr.success('Address added.');
                    this.angulartics2.eventTrack.next({
                        action: 'Add Address',
                        properties: {category: 'Profile'}
                    });
                }, err => {
					this.toastr.error("There was a problem creating the address");
				});
        } else {
            this.http.post('/api/v1/addresses/' + this.editModel.constituentAddressID, this.editModel)
                .subscribe(res => {
                    this.eventService.getAddresses(true).subscribe(() => {});
                    this.toastr.success('Address updated.');
                }, err => {
					this.toastr.error("There was a problem updating the address");
				});
        }
        this.isFormVisible = false;
        this.state.isSubmitted = false;
    }

    delete(address) {
        this.http.delete('/api/v1/addresses/' + address.constituentAddressID)
            .subscribe(res => {
                this.eventService.getAddresses(true).subscribe(() => {});
                this.toastr.success('Address deleted.');
                this.angulartics2.eventTrack.next({
                    action: 'Delete Address',
                    properties: {category: 'Profile'}
                });
            });
    }
}
